/* WPS free delivery progress: keeps every [data-wps-freeship] card in sync with the cart. */
(function () {
  function fmt(c) { var d = c / 100; return 'S$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2)); }
  function render(el, total) {
    var th = +el.dataset.threshold || 30000, left = Math.max(0, th - total), pct = Math.min(100, total / th * 100);
    var thTxt = fmt(th), state = total === 0 ? 'empty' : left === 0 ? 'done' : 'progress';
    var price = +el.dataset.price || 0, ctx = el.dataset.context;
    el.classList.remove('is-empty', 'is-progress', 'is-done'); el.classList.add('is-' + state);
    var q = function (s) { return el.querySelector(s); };
    q('[data-fs-total]').textContent = fmt(total);
    q('[data-fs-bar]').style.width = pct + '%';
    q('[data-fs-title]').textContent = state === 'done' ? "You've unlocked free delivery!" : state === 'empty' ? 'Free delivery on orders over ' + thTxt : "You're getting closer to free delivery!";
    var msg = q('[data-fs-msg]');
    if (state === 'done') msg.textContent = ctx === 'pdp' ? 'Your order ships free.' : 'Your order qualifies for free delivery across Singapore.';
    else if (state === 'empty') msg.textContent = ctx === 'pdp' ? 'Free delivery on orders over ' + thTxt + '.' : 'Orders below ' + thTxt + ' have a S$28 delivery fee.';
    else { msg.innerHTML = "You're just <strong>" + fmt(left) + '</strong> away from free delivery.'; }
    if (ctx === 'pdp' && state !== 'done' && price > 0 && price >= left) msg.innerHTML = 'Add this bottle and your order ships <strong>free</strong>.';
    var link = q('[data-fs-link]'); if (link) link.hidden = state === 'done';
  }
  // Estimated delivery: every Thursday. Wednesday -> "tomorrow"; Thursday -> next week's Thursday;
  // other days -> the coming Thursday. Worked out in Singapore time whatever the visitor's clock.
  function ordinal(n) { var s = ['th', 'st', 'nd', 'rd'], v = n % 100; return n + (s[(v - 20) % 10] || s[v] || s[0]); }
  function eta() {
    var now = new Date(Date.now() + 8 * 3600 * 1000); // shift to UTC+8, then read the UTC fields
    var dow = now.getUTCDay(), add = (4 - dow + 7) % 7 || 7;
    if (add === 1) return '<strong>tomorrow</strong>';
    var d = new Date(now.getTime() + add * 86400000);
    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return '<strong>Thursday ' + months[d.getUTCMonth()] + ' ' + ordinal(d.getUTCDate()) + '</strong>';
  }
  function fillEta() {
    document.querySelectorAll('[data-fs-eta]').forEach(function (p) { p.querySelector('span').innerHTML = 'Estimated delivery ' + eta(); p.hidden = false; });
  }
  function refresh() {
    var els = document.querySelectorAll('[data-wps-freeship]'); if (!els.length) return;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { els = document.querySelectorAll('[data-wps-freeship]'); els.forEach(function (el) { render(el, c.total_price); }); })
      .catch(function () {});
  }
  var t; function soon() { clearTimeout(t); t = setTimeout(refresh, 350); }
  // Any cart change made through fetch (add, change, update, clear) triggers a refresh.
  var of = window.fetch;
  if (of) window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = of.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(soon, soon);
    return p;
  };
  document.addEventListener('cart:updated', soon);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fillEta); else fillEta();
  document.addEventListener('DOMContentLoaded', function () {
    // PDP: the "this bottle gets you there" hint uses the selected variant's price.
    document.querySelectorAll('[data-wps-freeship][data-context="pdp"]').forEach(function (el) { if (+el.dataset.price) soon(); });
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
})();
